import { Sparkle } from '@phosphor-icons/react';
import { Icon } from '@shh/ui';
import type { ReactNode } from 'react';

/** "Ihr seid als Testfamilie eingeladen …" (1.17) – on the login and the start page. */
export function InviteHint({ children }: { children: ReactNode }) {
  return (
    <p
      role="status"
      className="flex items-start gap-gap-sm rounded-control bg-accent-secondary-soft p-inset-sm font-semibold"
    >
      <Icon icon={Sparkle} size="md" weight="fill" className="shrink-0 text-accent-secondary" />
      <span>{children}</span>
    </p>
  );
}
